<script>


import {useVuelidate} from '@vuelidate/core'
import {required, helpers} from '@vuelidate/validators'
import commentWithTools from "@/components/subcomponents/commentWithTools.vue";

export default {
  inject: ['$Q', '$DateTime', '$axios', '$_'],
  setup() {
    return {v$: useVuelidate()}
  },
  name: "FinalQA-Form",
  props: {
    'profileID': String,
    'dataFrom': String,
    loginData: Object
  },
  components: {
    commentWithTools
  },
  data() {
    return {
      feedbackSubmitted: false,
      feedbackSubmittedMsg: '',
      summaryProfile: {},
      summaryFeeback: {},
      summaryQA: {},
      summaryProfileLoaded: false,
      summaryFeebackLoaded: false,
      summaryQALoaded: false,


      currentData: {},
      feedbackViewBtn: '',
      isReadOnly: false,
      disableQASaving: false,
      feedbackApproval: {
        status: '',
        reason: ''
      },
      feebackQA: {
        surgeryAccuracy: {
          rating: '',
          comment: ''
        },
        storyQuoteQuality: {
          rating: '',
          comment: ''
        },
        imageQuality: {
          rating: '',
          comment: ''
        },
        safeScoreAccuracy: {
          rating: '',
          comment: ''
        },
      },
      approvalRemarksPlaceHolder: '',
      commentsArr: [],
      profileTS: '',
      profilePartner: ''
    }
  },
  validations() {
    let vm = this,
        validationObj = {};
    switch (vm.feedbackView) {
      case 'commentOnly':
        validationObj = {
          profileComment: {required: helpers.withMessage("Please provide the comment text", required)}
        }
        break;
    }
    return validationObj;
  },
  computed: {
    feedbackView() {
      let vm = this,
          returnValue = 'commentOnly';
      if (vm.dataFrom === 'rejectedFeedback') {
        returnValue = 'commentOnly'
      } else {
        if (vm.feedbackViewBtn === '') {
          switch (vm.currentData.role) {
            case 'Representative':
              returnValue = 'commentOnly'
              break;
            case 'Coordinator':
              returnValue = 'RateAndApprove'
              break;
          }
        } else {
          returnValue = vm.feedbackViewBtn;
        }
      }

      return returnValue;
    },
    sourceImageURLs() {
      let vm = this;
      let imageURLs = {
        preop: [],
        precondition: [],
        preids: [],
        preattachments: [],
        postop: [],
        postcondition: [],
        postattachments: []
      };
      vm.$_.forEach(vm.summaryFeeback.faceImages, function (faceImage) {
        imageURLs.postop.push({
          'src': faceImage.view,
          'data-source': faceImage.view,
        });
      });
      vm.$_.forEach(vm.summaryFeeback.conditionImages, function (conditionImage) {
        imageURLs.postcondition.push({
          'src': conditionImage.view,
          'data-source': conditionImage.view,
        });
      });
      imageURLs.postattachments.push({
        'src': vm.summaryFeeback.safeScaleReportImages[0].view,
        'data-source': vm.summaryFeeback.safeScaleReportImages[0].view,
      });
      vm.$_.forEach(vm.summaryFeeback.additionalAttachments, function (additionalAttachment) {
        imageURLs.postattachments.push({
          'src': additionalAttachment.view,
          'data-source': additionalAttachment.view,
        });
      });
      vm.$_.forEach(vm.commentsArr, function (comment, commentIndex) {
        imageURLs[`comment_${commentIndex}`] = [];
        vm.$_.forEach(comment.attachments, function (commentattachment) {
          imageURLs[`comment_${commentIndex}`].push({
            'src': commentattachment.view,
            'data-source': commentattachment.view,
          });
        });
      });
      return imageURLs;
    }
  },
  methods: {
    async validateForm() {
      await this.v$.$validate();
    },
    resize(textAreaRef) {
      let vm = this;
      let element = vm.$refs[textAreaRef];
      element.style.height = "18px";
      element.style.height = element.scrollHeight + "px";
    },
    fetchComments: function () {
      let vm = this;
      try {
        vm.$axios
            .post('/profile/action/fetchComments', {
              profileTS: vm.profileTS
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.currentData.token}`
              }
            })
            .then(function (response) {
              switch (response.data.success) {
                case 'true':
                  vm.commentsArr = response.data.comments;
                  break;
                case 'false':
                  vm.commentsArr = [];
                  break;
              }
            });
      } catch (error) {
        console.error(error);
      }
    }
  },
  async mounted() {
    let vm = this,
        storedAccount = localStorage.getItem("account");
    vm.IDB = await vm.getIDB()

    vm.summaryProfileLoaded = false;
    vm.summaryFeebackLoaded = false;
    vm.summaryQALoaded = false;
    vm.currentData = JSON.parse(storedAccount);

    let unapprovedFeedbackPatient = await vm.getPatientFromDb(vm.IDB, 'unapprovedFeedbacks', vm.profileID, 'caseId', false);

    if (typeof unapprovedFeedbackPatient[0] !== 'undefined') {
      vm.summaryProfile = unapprovedFeedbackPatient[0].caseData.profile;
      vm.summaryProfileLoaded = true;
      vm.summaryFeeback = unapprovedFeedbackPatient[0].caseData.feedback;
      vm.summaryFeebackLoaded = true;
      vm.summaryQA = unapprovedFeedbackPatient[0].caseData.caseQA;
      vm.summaryQALoaded = true;
      vm.profileTS = vm.$_.split(vm.profileID, '-')[1];
      vm.profilePartner = unapprovedFeedbackPatient[0].caseData.profile.partnerid;
    }


  },
}
</script>

<template>
  <div class="profile-form-container" v-if="!feedbackSubmitted">

    <div class="container" v-if="summaryFeebackLoaded">
      <div class="container">
        <div class="columns is-multiline is-vcentered">
          <div class="column is-full">
            <h1 class="is-size-3 is-underlined">Profile {{ profileID }}</h1>
          </div>
          <div class="column is-full">
            <div id="surgeryOne" class="columns is-multiline is-vcentered section-box">
              <div class="column is-full section-box-title-column">
                <div class="section-box-title-text">Profile Data</div>
              </div>
              <div class="column is-full can-scroll-content">
                <table class="table is-striped is-fullwidth">
                  <tbody>
                  <tr>
                    <td class="left-side-table-cell" colspan="3">
                      <label class="label has-text-left">Full Name</label>
                      <div class="has-text-centered">{{ summaryProfile.patientName }}</div>
                    </td>
                    <td class="right-side-table-cell" colspan="3">
                      <label class="label has-text-left">Patient Hospital Number</label>
                      <div class="has-text-centered">{{ summaryProfile.inpatientNumber }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td class="left-side-table-cell" colspan="3">
                      <label class="label has-text-left">Gender</label>
                      <div class="has-text-centered">{{ summaryProfile.patientGender }}</div>
                    </td>
                    <td class="right-side-table-cell" colspan="3">
                      <label class="label has-text-left">Date of Birth</label>
                      <div class="has-text-centered">{{ summaryProfile.patientDob }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td class="left-side-table-cell" colspan="2">
                      <label class="label has-text-left">Type</label>
                      <div class="has-text-centered">{{ summaryProfile.surgeryType }}</div>
                    </td>
                    <td class="middle-table-cell" colspan="2">
                      <label class="label has-text-left">Surgery required</label>
                      <div class="has-text-centered">{{ summaryProfile.surgeryRequired }}</div>
                    </td>
                    <td class="right-side-table-cell" colspan="2">
                      <label class="label has-text-left">Estimated Date of Surgery</label>
                      <div class="has-text-centered">{{ summaryProfile.estimatedSurgeryDay }}</div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="columns is-multiline is-vcentered">
          <div class="column is-full">
            <h1 class="is-size-3 is-underlined">Surgery</h1>
          </div>
          <div class="column is-full">
            <div id="surgeryData" class="columns is-multiline is-vcentered section-box">
              <div class="column is-full section-box-title-column">
                <div class="section-box-title-text">Surgery Data</div>
              </div>
              <div class="column is-full can-scroll-content">
                <table class="table is-striped is-fullwidth">
                  <tbody>
                  <tr>
                    <td class="left-side-table-cell" colspan="3">
                      <label class="label has-text-left">Status</label>
                      <div class="has-text-centered">{{ summaryFeeback.surgeryStatus }}</div>
                    </td>
                    <td class="right-side-table-cell" colspan="3"
                        v-if="summaryFeeback.surgeryStatus==='Done'">
                      <label class="label has-text-left">Actual Surgery</label>
                      <div class="has-text-centered">{{ summaryFeeback.actualSurgery }}</div>
                    </td>
                    <td class="right-side-table-cell" colspan="3" v-else>
                      <label class="label has-text-left">Reason</label>
                      <div class="has-text-centered">{{ summaryFeeback.surgeryStatusReason }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td class="left-side-table-cell" colspan="2">
                      <label class="label has-text-left">Admission</label>
                      <div class="has-text-centered">{{ summaryFeeback.admissionData }}</div>
                    </td>
                    <td class="right-side-table-cell" colspan="2">
                      <label class="label has-text-left">Surgery</label>
                      <div class="has-text-centered">{{ summaryFeeback.surgeryData }}</div>
                    </td>
                    <td class="right-side-table-cell" colspan="2">
                      <label class="label has-text-left">Discharge</label>
                      <div class="has-text-centered">{{ summaryFeeback.dischargeData }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td class="left-side-table-cell" colspan="3">
                      <label class="label has-text-left">Final Bill</label>
                      <div class="has-text-centered">{{ summaryFeeback.finalBill }}</div>
                    </td>
                    <td class="middle-table-cell" colspan="3">
                      <label class="label has-text-left">Co-payment</label>
                      <div class="has-text-centered" v-html="summaryFeeback.coPaymentDisplay"></div>
                    </td>
                  </tr>
                  <tr>
                    <td class="left-side-table-cell" colspan="3">
                      <label class="label has-text-left">SAFE-Score Rating</label>
                      <div class="has-text-centered">{{ summaryFeeback.safeScoreRating }}</div>
                    </td>
                    <td class="middle-table-cell" colspan="3">
                      <label class="label has-text-left">SAFE-Score Comment</label>
                      <div class="has-text-centered" v-html="summaryFeeback.safeScoreComment"></div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container" v-if="summaryFeeback.isBirthSurgery==='YES'">
        <div class="columns is-multiline is-vcentered">
          <div class="column is-full">
            <h1 class="is-size-3">&nbsp;</h1>
          </div>
          <div class="column is-full">
            <div id="surgeryBirth" class="columns is-multiline is-vcentered section-box">
              <div class="column is-full section-box-title-column">
                <div class="section-box-title-text">Birth Outcome</div>
              </div>
              <div class="column is-full can-scroll-content">
                <table class="table is-striped is-fullwidth">
                  <tbody>
                  <tr>
                    <td class="left-side-table-cell" colspan="2">
                      <label class="label has-text-left">Gravidity</label>
                      <div class="has-text-centered">{{ summaryFeeback.birthOutcomeGravidity }}</div>
                    </td>
                    <td class="right-side-table-cell" colspan="2">
                      <label class="label has-text-left">Parity</label>
                      <div class="has-text-centered">{{ summaryFeeback.birthOutcomeParity }}</div>
                    </td>
                    <td class="right-side-table-cell" colspan="2">
                      <label class="label has-text-left">Births</label>
                      <div class="has-text-centered">{{ summaryFeeback.birthOutcomeChildrenCount }}</div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="6">
                      <div class="columns is-multiline is-vcentered">
                        <div class="column is-full"></div>
                        <div v-for="(child, index) in summaryFeeback.childrenFormated"
                             class="column is-half has-text-centered" v-bind:key="index"
                             v-html="child"></div>
                        <div class="column is-full"></div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="columns is-multiline is-vcentered">
          <div class="column is-full">
            <h1 class="is-size-3">&nbsp;</h1>
          </div>
          <div class="column is-full">
            <div id="surgeryData" class="columns is-multiline is-vcentered section-box">
              <div class="column is-full section-box-title-column">
                <div class="section-box-title-text">Patient Story</div>
              </div>
              <div class="column is-full" v-html="summaryFeeback.patientStory"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="columns is-multiline is-vcentered">
          <div class="column is-full">
            <h1 class="is-size-3">&nbsp;</h1>
          </div>
          <div class="column is-full">
            <div id="surgeryData" class="columns is-multiline is-vcentered section-box">
              <div class="column is-full section-box-title-column">
                <div class="section-box-title-text">Patient Quote</div>
              </div>
              <div class="column is-full" v-html="summaryFeeback.patientQuote"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="columns is-multiline">

          <div class="column is-full">
            <h1 class="is-size-3 is-underlined">Patient Photo(s)</h1>
          </div>

          <div class="column is-full" v-if="summaryFeeback.faceImages.length!==0">
            <div id="AttachmentsTwo" class="columns is-multiline is-vcentered section-box">
              <div class="column is-full section-box-title-column">
                <div class="section-box-title-text">Post-OP Photos</div>
              </div>
              <div class="column is-half input-no-padding-top"
                   v-for="(faceImage, index) in summaryFeeback.faceImages"
                   v-bind:key="index">
                <div class="image-relative-container">
                  <div class="image-flex-container">
                    <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face" class="image">
                  </div>
                  <div class="image-flex-container"><strong>Timestamp:</strong> <span>{{ faceImage.timestamp }}</span>
                  </div>
                  <div><strong>Location:</strong>
                    <a v-bind:href="faceImage.location" target="_blank" v-if="faceImage.location!==''">Here</a>
                    <span v-else></span>
                  </div>
                  <a v-bind:href="`${faceImage.download}?form=feedback&fullname=${summaryProfile.patientName}`"
                     target="_blank" class="button is-fullwidth">Download</a>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-full" v-if="summaryFeeback.conditionImages.length!==0"></div>
          <div class="column is-full" v-if="summaryFeeback.conditionImages.length!==0">
            <div id="AttachmentsThree" class="columns is-multiline is-vcentered section-box">
              <div class="column is-full section-box-title-column">
                <div class="section-box-title-text">Condition</div>
              </div>
              <div class="column is-half input-no-padding-top"
                   v-for="(conditionImage, index) in summaryFeeback.conditionImages"
                   v-bind:key="index">
                <div class="image-relative-container">
                  <div class="image-flex-container">
                    <img v-bind:src="`${conditionImage.thumbnail}`" alt="Condition Image"
                         class="image">
                  </div>
                  <div class="image-flex-container"><strong>Timestamp:</strong> <span>{{
                      conditionImage.timestamp
                    }}</span></div>
                  <div><strong>Location:</strong> <a v-bind:href="conditionImage.location" target="_blank"
                                                     v-if="conditionImage.location!==''">Here</a>
                    <span v-else></span>
                  </div>
                  <a v-bind:href="`${conditionImage.download}?form=feedback&fullname=${summaryProfile.patientName}`"
                     target="_blank"
                     class="button is-fullwidth">Download</a>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-full"></div>
          <div class="column is-full">
            <div id="additionalAttachments" class="columns is-multiline is-vcentered section-box">
              <div class="column is-full section-box-title-column">
                <div class="section-box-title-text">Additional Attachments</div>
              </div>
              <div class="column is-one-quarter">
                <div class="image-relative-container">
                  <div class="image-flex-container">
                    <img v-bind:src="`${summaryFeeback.safeScaleReportImages[0].thumbnail}`"
                         alt="Surgical Outcome Document"
                         class="image">
                  </div>
                  <a v-bind:href="`${summaryFeeback.safeScaleReportImages[0].download}?form=feedback&fullname=${summaryProfile.patientName}`"
                     target="_blank"
                     class="button is-fullwidth">Download</a>
                </div>
              </div>
              <div class="column is-one-quarter"
                   v-for="(additionalAttachment, index) in summaryFeeback.additionalAttachments"
                   v-bind:key="index">
                <div class="image-relative-container">
                  <div class="image-flex-container">
                    <img v-bind:src="`${additionalAttachment.thumbnail}`"
                         alt="Additional Attachment"
                         class="image">
                  </div>
                  <a v-bind:href="`${additionalAttachment.download}?form=feedback&fullname=${summaryProfile.patientName}`"
                     target="_blank"
                     class="button is-fullwidth">Download</a>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-full"></div>
          <div class="column is-full">
            <div id="AttachmentsSeven" class="columns is-multiline is-vcentered section-box">
              <div class="column is-full section-box-title-column">
                <div class="section-box-title-text">Acknowledgement</div>
              </div>
              <div class="column is-full can-scroll-content">
                <table class="table is-striped is-fullwidth">
                  <tbody>
                  <tr>
                    <td>
                      <label class="label has-text-left">By submitting this form, you acknowledge that all of the
                        information contained in this document is true to the best of your knowledge. If at any
                        point the information contained above becomes inaccurate, you agree to notify the SAFE
                        Program as soon as possible.</label>
                      <div class="has-text-centered">{{ summaryFeeback.signedAcknowledgement }}</div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="column is-full"></div>

        </div>
      </div>
      <div class="container">
        <div class="columns is-multiline is-mobile">
          <div class="column is-full">
            <h1 class="is-size-3 is-underlined" v-if="currentData.role==='Representative'">Comments</h1>
          </div>
          <div class="column is-full" v-if="feedbackView==='commentOnly'">
            <div id="CoordFeedbackOne" class="columns is-multiline is-mobile is-vcentered section-box">
              <div class="column is-full section-box-title-column">
                <div class="section-box-title-text">Comments</div>
              </div>
              <div class="column is-full can-scroll-content">
                <table class="table is-striped is-fullwidth">
                  <tbody>
                  <tr v-if="commentsArr.length===0 && isReadOnly">
                    <td>There are no comments</td>
                  </tr>
                  <tr v-for="(comment, commentIndex) in commentsArr"
                      v-bind:key="commentIndex">
                    <td>
                      <div class="columns is-multiline">
                        <div class="column is-full has-text-justified">{{ comment.commentText }}</div>
                        <div class="column is-one-quarter"
                             v-for="(attachment, attachmentIndex) in comment.attachments"
                             v-bind:key="attachmentIndex">
                          <div class="image-relative-container"
                               v-on:click="previewURL(`comment_${commentIndex}`,attachmentIndex)">
                            <div class="image-flex-container zoom-image">
                              <img v-bind:src="`${attachment.thumbnail}`" alt="Comment Attachment" class="image">
                            </div>
                          </div>
                          <a v-bind:href="`${attachment.download}?form=comment&fullname=${summaryProfile.patientName}`"
                             target="_blank"
                             class="button is-fullwidth">Download</a>
                        </div>
                        <div class="column is-full has-text-right">{{ comment.postdBy.name }} at {{
                            comment.commentDate
                          }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!isReadOnly">
                    <td>
                      <commentWithTools
                          v-bind:profileTS="profileTS"
                          v-bind:profilePartner="profilePartner"
                          v-bind:textAreaPlaceholder="''"
                          v-bind:textAreaGuideline="''"
                          v-bind:commentError="false"
                          v-on:commentPosted="fetchComments"
                      >
                      </commentWithTools>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="column is-full"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
@import "@/assets/fontawesome-free-6.5.2-web/css/all.min.css";

.profile-form-container {
  padding: 20px;
}

[v-cloak] {
  display: none;
}

.error-input {
  border: 1px solid red !important;
  background-color: #ffefef !important;
  opacity: 0.9 !important;
}

.left-side-table-cell {
  border-right: 1px solid hsl(0, 0%, 86%) !important;
}

.right-side-table-cell {
  border-left: 1px solid hsl(0, 0%, 86%) !important;
}

.middle-table-cell {
  border-right: 1px solid hsl(0, 0%, 86%) !important;
  border-left: 1px solid hsl(0, 0%, 86%) !important;
}

.is-200x200 {
  height: 200px;
  width: 200px;
}

.can-scroll-content {
  overflow-x: scroll;
}

.qa-ok {
  color: green;
}

.qa-nok {
  color: red;
}
</style>